// extracted by mini-css-extract-plugin
export var button = "_br-7";
export var buttonRow = "_br-6";
export var fadeIn = "_br-1";
export var gradient = "_br-0";
export var panel = "_br-2";
export var panelIn = "_br-3";
export var subtitle = "_br-5";
export var title = "_br-4";